'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function zipWith(arr1) {
    var _loop = function(i) {
        var elements = arrs.map(function(arr) {
            return arr[i];
        });
        result[i] = combine.apply(void 0, _to_consumable_array(elements));
    };
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    var _Math;
    var arrs = [
        arr1
    ].concat(_to_consumable_array(rest.slice(0, -1)));
    var combine = rest[rest.length - 1];
    var maxIndex = (_Math = Math).max.apply(_Math, _to_consumable_array(arrs.map(function(arr) {
        return arr.length;
    })));
    var result = Array(maxIndex);
    for(var i = 0; i < maxIndex; i++)_loop(i);
    return result;
}
exports.zipWith = zipWith;
